/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import axios from 'axios';

import HeaderTitle from "../../components/includes/HeaderTitle";
import StaffWorkingSearch from "../../components/members/StaffWorkingSearch";
import StaffWorkingSearchResult from "../../components/members/StaffWorkingSearchResult";
import Paging from "../../components/includes/Paging";
import {LoginAfterCheckLogin} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

//직원 관리
const StaffWorkingList = ({setMenuType,setMenuItem}) => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검

  //회원목록
  const [varStaffWorkingLists,setStaffWorkingLists] = useState([]);
  
  //페이지
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);
  const [varMaxNumPage, setMaxNumPage] = useState(0);

  //검색
  const [varSearchData, setSearchData] = useState({
    sdate:null,
    edate:null,
    searchOption:'all',
    searchString:'',
    searchWorking:0
  });

  //회원목록 읽어오기
  const getStaffWorkingList = async () => {
    const sendData = {pageNum: varPageNum,pageSize: varPageSize,searchData: varSearchData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_get_staffworking_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setTotalCount(datas.totalcount);
        setStaffWorkingLists(datas.results);
        setMaxNumPage(datas.totalcount-(varPageNum-1)*varPageSize);
      } else {
        setStaffWorkingLists([]);
        setTotalCount(0);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setMenuType('MEMBER');
    setMenuItem('StaffWorkingList');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getStaffWorkingList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum,varSearchData]);

  return (
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="직원관리" varPageTitle="근태 관리" />
      <div className="admin-content">
        <StaffWorkingSearch varTotalCount={varTotalCount}  varSearchData={varSearchData} setSearchData={setSearchData} />
        <StaffWorkingSearchResult varMaxNumPage={varMaxNumPage} varStaffWorkingLists={varStaffWorkingLists} setStaffWorkingLists={setStaffWorkingLists}/>
        <div className="paging" style={{ marginBottom: "20px" }}>
          <Paging totalCount={varTotalCount} pageSize={varPageSize} curPage={varPageNum} setPage={setPageNum} />
        </div>
      </div>
    </div>
  );
}
export default StaffWorkingList;